import OktaCookie from "../interfaces/OktaCookie";
type LocalStorageKeys = "okta-token-storage" | "masqueraded-user";

const getLocalStorageValue = (key: LocalStorageKeys): string => {
  const value: string | null = localStorage.getItem(key);

  return value ? value : "";
};

const setLocalStorageValue = (key: LocalStorageKeys, value: string) => {
  localStorage.setItem(key, value);
};

const removeLocalStorageValue = (key: LocalStorageKeys) => {
  localStorage.removeItem(key);
};

const getOktaAccessToken = (): string => {
  const oktaCookie: string = getLocalStorageValue("okta-token-storage");
  let accessToken: string = "";
  if (oktaCookie) {
    const token: OktaCookie = JSON.parse(oktaCookie);
    accessToken = token.accessToken.accessToken;
  }

  return accessToken;
};

const getOktaUser = (): string[] => {
  const oktaCookie: string = getLocalStorageValue("okta-token-storage");
  let idToken: string[] = [];

  if (oktaCookie) {
    const token: OktaCookie = JSON.parse(oktaCookie);
    idToken.push(token.idToken.claims?.name as string);
    idToken.push(token.idToken.claims?.email as string);
    idToken.push(token.idToken.claims?.["cfa-login"] as string);
    idToken.push(token.accessToken.claims?.employeeNumber as string);
  }

  return idToken;
};

const getUserPermissions = (): any => {
  const oktaCookie: string = getLocalStorageValue("okta-token-storage");
  let treasuryPermissions;

  if (oktaCookie) {
    const token: OktaCookie = JSON.parse(oktaCookie);
    treasuryPermissions = token.idToken.claims?.cfa_perms?.TREASURY_DASHBOARD;
  }
  return treasuryPermissions;
};

export {
  setLocalStorageValue,
  removeLocalStorageValue,
  getOktaAccessToken,
  getOktaUser,
  getUserPermissions,
};
